import PropTypes from 'prop-types';
import React from 'react';
import CompactText from 'modules/Common/components/CompactText';
import FootballMatchOutcomeDescription from 'modules/Football/components/FootballMatchOutcomeDescription';

function getId(team) {
  return team.team_reference.id;
}

function getTeam(match, code) {
  const teamScore = match[`team_score_${code}`];

  const id = getId(teamScore.team);
  const name = teamScore.team.name;
  const short_name = teamScore.team.short_name;
  const [{score = ''} = {}] = teamScore.score;

  let outcome = "DRAW_LOSS";

  if(match.match_outcome && match.match_outcome.outcome == "WIN"){
    const winningId = getId(match.match_outcome.winner);

    if(winningId == id){
      outcome = "WON";
    }
  }

  return {
    id,
    name,
    short_name,
    score,
    outcome
  };
}

export default function FootballMatchFormMatch({match}) {
  require('./FootballMatchForm.scss');

  const homeTeam = getTeam(match, 'a');
  const awayTeam = getTeam(match, 'b');

  return (
    <div className="formMatch">
      <div className="formMatchScores">
        <div className={`homeTeam-${homeTeam.outcome}`}><CompactText compactText={homeTeam.short_name}>{homeTeam.name}</CompactText></div>
        <div className="scoreBox">
          <div className="grey-score-box">{homeTeam.score}-{awayTeam.score}</div>
        </div>
        <div className={`awayTeam-${awayTeam.outcome}`}><CompactText compactText={awayTeam.short_name}>{awayTeam.name}</CompactText></div>
      </div>
      <FootballMatchOutcomeDescription matchOutcome={match.match_outcome} penaltyShootoutScore={match.penalty_shootout_score}/>
    </div>
  );
}

FootballMatchFormMatch.propTypes = {
  match: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchFormMatch.js